import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Badge, Box, Card, Divider, Flex, Link, Text, useColorMode } from 'theme-ui';
import { getAllBcPcHistory } from '../../store/actions/masterData.action';
import moment from 'moment';
import theme from '../../theme';

const BCPCRevHistory = ({ Open, setOpen, actionObject }: any) => {
  const { bcpcHistory } = useSelector((state: any) => state.masterData);
  const dispatch = useDispatch();

  const projectName = bcpcHistory?.data?.BCs?.[0]?.projectId?.name || bcpcHistory?.data?.PCs?.[0]?.projectId?.name || bcpcHistory?.data?.Revs?.[0]?.projectId?.name;
  const stageColor = bcpcHistory?.data?.BCs?.[0]?.stageId?.color || bcpcHistory?.data?.PCs?.[0]?.stageId?.color || bcpcHistory?.data?.Revs?.[0]?.stageId?.color;
  const stageName = (bcpcHistory?.data?.BCs?.[0]?.stageId?.temporaryName || bcpcHistory?.data?.BCs?.[0]?.stageId?.name) ||
                   (bcpcHistory?.data?.PCs?.[0]?.stageId?.temporaryName || bcpcHistory?.data?.PCs?.[0]?.stageId?.name) ||
                   (bcpcHistory?.data?.Revs?.[0]?.stageId?.temporaryName || bcpcHistory?.data?.Revs?.[0]?.stageId?.name);

  const togglePopover = () => {
    setOpen(!Open);
  };
  useEffect(() => {
    dispatch(getAllBcPcHistory(actionObject?.stageId || actionObject?.stageDataId))
  }, [actionObject?.stageId, actionObject?.stageDataId, dispatch]);

  const [colorMode] = useColorMode();
  const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
  const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";
  const cardBg = colorMode === 'light' ? "#fff" : "#2e354db8";
  const closeButton = (
    <button
      type="button"
      aria-label="Close"
      onClick={togglePopover}
      style={{
        color: colorMode === 'dark' ? '#fff' : '#000',
        background: 'transparent',
        border: 'none',
        fontSize: 23,
        lineHeight: 1,
        padding: 0,
        cursor: 'pointer'
      }}
    >
      <span aria-hidden="true">&times;</span>
    </button>
  );
  return (
    <Modal isOpen={Open} centered scrollable size='xl' toggle={togglePopover}>
      <ModalHeader toggle={togglePopover} close={closeButton} style={{ backgroundColor: modalHeader, color: titleHeader }}>{projectName}</ModalHeader>
      <ModalBody style={{ backgroundColor: modalHeader }}>
        <Card sx={{ boxShadow: "none", border: `1px solid ${theme?.colors?.lightbackground}`, borderRadius: "12px", padding: "12px 20px", position: "relative", background: cardBg }}>
          <Flex >
            <Badge sx={{
              color: stageColor ? stageColor : colorMode === "light" ? "black" : "white",
              border: stageColor ? `1px solid ${stageColor}` : colorMode === "light" ? '1px solid black' : '1px solid white',
              borderRadius: 6,
              backgroundColor: "transparent",
              margin: "5px",
              fontSize: '20px'
            }}>
              {stageName}
            </Badge>
          </Flex>
          <Divider />
          {bcpcHistory?.data?.BCs && (
            <>
              <Flex >
                <Text variant="SelectLabel" sx={{ color: '#7AC555' }}>Background Change</Text>
              </Flex>
              {bcpcHistory?.data?.BCs?.map((bc: any, index: number) => (
                <Box key={index} sx={{ listStyleType: 'none' }}>
                  {bc?.payload?.name && <Text as='li' sx={{ color: titleHeader }}><Text variant="SelectLabel" sx={{ lineHeight: '30px', color: titleHeader }}>Name:</Text> {`${bc?.payload?.name}. (${bc?.payload?.number})`}</Text>}
                  {bc?.payload?.description && <Text as='li' sx={{ color: titleHeader }}><Text variant="SelectLabel" sx={{ lineHeight: '30px', color: titleHeader }}>Description:</Text> {bc?.payload?.description}</Text>}
                  {bc?.payload?.emailLink && bc?.payload?.emailLink.length > 0 && (
                    <Text as='li' variant="SelectLabel" sx={{ color: titleHeader }}>
                      Email Link:
                      <Text variant="Poppins14Normal" className='ms-2'>
                        {bc?.payload?.emailLink.map((email: string, emailIndex: number) => (
                          <React.Fragment key={emailIndex}>
                            <Link
                              target='_blank'
                              href={email}
                              sx={{ textDecoration: 'none', cursor: 'pointer' }}
                            >
                              {email}
                            </Link>
                            {emailIndex < bc?.payload?.emailLink.length - 1 && ', '}
                          </React.Fragment>
                        ))}
                      </Text>
                    </Text>
                  )}
                  {bc?.createdAt && <Text as='li' sx={{ color: titleHeader }}><Text variant="SelectLabel" sx={{ lineHeight: '30px', color: titleHeader }}>Created Date:</Text>  {moment(bc?.createdAt).format('YYYY-MM-DD')}</Text>}
                </Box>
              ))}
            </>
          )}
          <Divider />
          {bcpcHistory?.data?.PCs && (
            <>
              <Flex >
                <Text variant="SelectLabel" sx={{ color: '#03AECC' }}>Plan Check</Text>
              </Flex>
              {bcpcHistory?.data?.PCs?.map((pc: any, index: number) => (
                <Box key={index} sx={{ listStyleType: 'none' }}>
                  {pc?.payload?.name && <Text as='li' sx={{ color: titleHeader }}><Text variant="SelectLabel" sx={{ lineHeight: '30px', color: titleHeader }}>Name:</Text> {`${pc?.payload?.name}. (${pc?.payload?.number})`}</Text>}
                  {pc?.payload?.description && <Text as='li' sx={{ color: titleHeader }}><Text variant="SelectLabel" sx={{ lineHeight: '30px', color: titleHeader }}>Description:</Text> {pc?.payload?.description}</Text>}
                  {pc?.payload?.emailLink && pc?.payload?.emailLink.length > 0 && (
                    <Text as='li' variant="SelectLabel" sx={{ color: titleHeader }}>
                      Email Link:
                      <Text variant="Poppins14Normal" className='ms-2'>
                        {pc?.payload?.emailLink.map((email: string, emailIndex: number) => (
                          <React.Fragment key={emailIndex}>
                            <Link
                              target='_blank'
                              href={email}
                              sx={{ textDecoration: 'none', cursor: 'pointer' }}
                            >
                              {email}
                            </Link>
                            {emailIndex < pc?.payload?.emailLink.length - 1 && ', '}
                          </React.Fragment>
                        ))}
                      </Text>
                    </Text>
                  )}
                  {pc?.createdAt && <Text as='li' sx={{ color: titleHeader }}><Text variant="SelectLabel" sx={{ lineHeight: '30px', color: titleHeader }}>Created Date:</Text>  {moment(pc?.createdAt).format('YYYY-MM-DD')}</Text>}
                </Box>
              ))}
            </>
          )}
          <Divider />
          {bcpcHistory?.data?.Revs && (
            <>
              <Flex >
                <Text variant="SelectLabel" sx={{ color: '#FF8FD4' }}>Revision</Text>
              </Flex>
              {bcpcHistory?.data?.Revs?.map((rev: any, index: number) => (
                <Box key={index} sx={{ listStyleType: 'none' }}>
                  {rev?.payload?.name && <Text as='li' sx={{ color: titleHeader }}><Text variant="SelectLabel" sx={{ lineHeight: '30px', color: titleHeader }}>Name:</Text> {`${rev?.payload?.name}. (${rev?.payload?.number})`}</Text>}
                  {rev?.payload?.description && <Text as='li' sx={{ color: titleHeader }}><Text variant="SelectLabel" sx={{ lineHeight: '30px', color: titleHeader }}>Description:</Text> {rev?.payload?.description}</Text>}
                  {rev?.payload?.emailLink && rev?.payload?.emailLink.length > 0 && (
                    <Text as='li' variant="SelectLabel" sx={{ color: titleHeader }}>
                      Email Link:
                      <Text variant="Poppins14Normal" className='ms-2'>
                        {rev?.payload?.emailLink.map((email: string, emailIndex: number) => (
                          <React.Fragment key={emailIndex}>
                            <Link
                              target='_blank'
                              href={email}
                              sx={{ textDecoration: 'none', cursor: 'pointer' }}
                            >
                              {email}
                            </Link>
                            {emailIndex < rev?.payload?.emailLink.length - 1 && ', '}
                          </React.Fragment>
                        ))}
                      </Text>
                    </Text>
                  )}
                  {rev?.createdAt && <Text as='li' sx={{ color: titleHeader }}><Text variant="SelectLabel" sx={{ lineHeight: '30px', color: titleHeader }}>Created Date:</Text>  {moment(rev?.createdAt).format('YYYY-MM-DD')}</Text>}
                </Box>
              ))}
            </>
          )}
        </Card>
      </ModalBody>
    </Modal>
  )
}

export default BCPCRevHistory